import { Box, Fab, Grid, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import React, { useEffect, useState } from "react";
import { List, ListItemButton, ListItemText, Collapse } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// import { useLocation } from "react-router/dist";

import { ExpandLess, ExpandMore } from "@mui/icons-material";
import AdvertisementBar from "./advertisementBar";
import Port from "./port";


const AdminSidebar = () => {
  const menuLoginHeader = [
    {
      title: "Home",
    },
    {
      title: "About",
    },
  ];

  const barName = useSelector((state) => state.reducer.barName);


  const [currentPage, setCurrentPage] = useState(-1);
  const navigate = useNavigate();
  //   const urlHeaderMenu = useSelector((state) => state.reducer.urlHeaderMenu);
  const urlHeaderMenuAdmin = useSelector(
    (state) => state.reducer.urlHeaderMenuAdmin
  );
 
  const location = useLocation();
  const activeIndex = urlHeaderMenuAdmin.findIndex(
    (item) => item.route === location.pathname
  );

  // const titleHead1 = (ele) => {
  //   const indexRoute = headerMenu.findIndex(
  //     (it) => it.systemFuctionName === ele.systemFuctionName
  //   );
  //   // if (NameData[ele?.systemFuctionName]) {
  //   //   return ele?.systemFuctionName;
  //   // }
  //   // if (headerMenu[indexRoute]?.regionalFunctionName.includes("Counter Sale")) {
  //   //   return "Billing";
  //   // }
  //   return headerMenu[indexRoute]?.regionalFunctionName;
  // };
  useEffect(() => {
    console.log("barName ", urlHeaderMenuAdmin);
  }, [urlHeaderMenuAdmin]);
  // useEffect(() => {
  //   const index = urlHeaderMenuAdmin?.findIndex((item) => {
  //     // const tt = titleHead1(item);
  //     // if (tt === "Advertisement & Offers" && barName === "adverticement") {
  //     //   return location.pathname === analatics?.route;
  //     // }
  //     // if (tt === "Customer Management" && barName === "CustomerMangment") {
  //     //   return location.pathname === customerChategory[0]?.route;
  //     // }
  //     // if (tt === "Business Management" && barName === "bussinessMangment") {
  //     //   return location.pathname === bussinessMangementMenu[0]?.route;
  //     // }
  //     return location.pathname === item?.route;
  //   });

  //   if (index !== -1) {
  //     setActive(index);
  //   }
  // }, [location.pathname, urlHeaderMenuAdmin, barName]);
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        height: "100vh",
        borderRight: "1px solid #eee",
      }}
    >
      <List component="nav">
        {urlHeaderMenuAdmin?.map((item, index) => {
          // if(urlHeaderMenu.length-1==  index){
          //   return null
          // }
          console.log("Sidebar Item ===", item);

          return (
            <React.Fragment>
              <ListItemButton
                onClick={(e) => {
                  // setActive(index);
                 item.systemFuctionName !== "UserProfile" &&
                   item.systemFuctionName !== "Recharge" &&
                   e.stopPropagation();

                  navigate(item?.route);
                }}
                sx={{
                  // background:
                  //   active === index
                  //     ? "linear-gradient(to right, #0c0079, #e4e2f4)"
                  //     : "",
                  // color: active === index ? "white" : "black",
                  background:
                    activeIndex === index
                      ? "linear-gradient(to right, #0c0079, #e4e2f4)"
                      : "",
                  color: activeIndex === index ? "white" : "black",
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontWeight: currentPage === index ? 600 : 400,
                        fontSize: { xs: "15px", sm: "13px", md: "15px" },
                      }}
                    >
                      {/* {titleHead1(item) == "UserProfile"
                        ? "UserProfile"
                        : titleHead1(item)} */}
                      {item.systemFuctionName }
                    </Typography>
                  }
                />
                {/* {active === index ? <ExpandLess /> : <ExpandMore />} */}
                {item.systemFuctionName !== "UserProfile" &&
                  item.systemFuctionName !== "Recharge" && (
                    <Box
                      component={ExpandMore}
                      sx={{
                        transform:
                          activeIndex === index
                            ? "rotate(0deg)"
                            : "rotate(-90deg)",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  )}
              </ListItemButton>

              {item.systemFuctionName == "Advertisement & Offers" &&
                barName == "adverticement" && (
                  <AdvertisementBar menuLoginHeader={menuLoginHeader} />
                )}
              {item.systemFuctionName == "Support" && barName == "Support" && (
                <Port menuLoginHeader={menuLoginHeader} />
              )}
              
            </React.Fragment>
          );
        })}
       </List>
    </Box>
  );
};

export default AdminSidebar;

// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   List,
//   ListItemButton,
//   ListItemText,
//   Typography,
// } from "@mui/material";
// import { ExpandMore } from "@mui/icons-material";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";

// import AdvertisementBar from "./advertisementBar";
// import Port from "./port";

// const AdminSidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const urlHeaderMenuAdmin = useSelector(
//     (state) => state.reducer.urlHeaderMenuAdmin
//   );
//   const barName = useSelector((state) => state.reducer.barName);

//   const [openSection, setOpenSection] = useState(null);

//   const activeIndex = urlHeaderMenuAdmin.findIndex(
//     (item) => item.route === location.pathname
//   );

//   // Handle section click
//   const handleClick = (item) => {
//     const name = item.systemFuctionName;

//     if (name === "Advertisement & Offers" || name === "Support") {
//       // toggle open/close locally
//       setOpenSection(openSection === name ? null : name);
//       // optional: dispatch Redux name if needed
//       dispatch({
//         type: "SET_BAR_NAME",
//         payload:
//           name === "Advertisement & Offers" ? "adverticement" : "Support",
//       });
//     } else {
//       navigate(item.route); // normal navigation
//       setOpenSection(null); // close any open section
//     }
//   };

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         backgroundColor: "#fff",
//         height: "100vh",
//         borderRight: "1px solid #eee",
//         overflowY: "auto",
//       }}
//     >
//       <List component="nav">
//         {urlHeaderMenuAdmin?.map((item, index) => {
//           const isActive = activeIndex === index;
//           const name = item.systemFuctionName;

//           return (
//             <React.Fragment key={index}>
//               <ListItemButton
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleClick(item);
//                 }}
//                 sx={{
//                   background: isActive
//                     ? "linear-gradient(to right, #0c0079, #e4e2f4)"
//                     : "",
//                   color: isActive ? "white" : "black",
//                 }}
//               >
//                 <ListItemText
//                   primary={
//                     <Typography
//                       sx={{
//                         fontWeight: isActive ? 600 : 400,
//                         fontSize: { xs: "15px", sm: "13px", md: "15px" },
//                       }}
//                     >
//                       {name || "NO NAME FOUND"}
//                     </Typography>
//                   }
//                 />
//                 {/* Show arrow only for expandable items */}
//                 {name !== "UserProfile" &&
//                   name !== "Recharge" &&
//                   (name === "Advertisement & Offers" || name === "Support") && (
//                     <Box
//                       component={ExpandMore}
//                       sx={{
//                         transform:
//                           openSection === name
//                             ? "rotate(0deg)"
//                             : "rotate(-90deg)",
//                         transition: "transform 0.3s ease",
//                       }}
//                     />
//                   )}
//               </ListItemButton>

//               {/* Expandable submenus */}
//               {name === "Advertisement & Offers" && openSection === name && (
//                 <AdvertisementBar />
//               )}
//               {name === "Support" && openSection === name && <Port />}
//             </React.Fragment>
//           );
//         })}
//       </List>
//     </Box>
//   );
// };

// export default AdminSidebar;
